import React, { createContext, useState, useEffect, useContext } from "react";
import AuthContext from "./AuthContext";
import axios from "axios";
import Cookies from "universal-cookie";
import { host, initialClients } from "./../components/utils";
import jwt_decode from "jwt-decode";
import { useMemo } from "react";
import {
  getPieEntry,
  mergeSources,
  add,
  groupBy,
  funnelDataInitial,
  pieDataInitial,
} from "../components/utils.js";
import {positions as posInit, positionsArchived as posArchivedInit} from "../components/positions.js";

const cookies = new Cookies();

const DataContext = createContext();

export default DataContext;

export const DataProvider = ({ children }) => {
  let { isAuthenticated, authToken, logoutUser, isAdmin } =
    useContext(AuthContext);

  //client position view stuff
  const [clientPositions, setClientPositions] = useState([]);
  const [clientPositionId, setClientPositionId] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [clientChecked, setClientChecked] = useState();
  const [clientName, setClientName] = useState(null);

  const [positions, setPositions] = useState(posInit);
  const [clients, setClients] = useState(initialClients);
  const [archivedPositions, setArchivedPositions] = useState(posArchivedInit);
  const [archivedClients, setArchivedClients] = useState([]);

  //client state
  const [clientPieChartData, setClientPieChartData] = useState(pieDataInitial);
  const [clientFunnelData, setClientFunnelData] = useState(funnelDataInitial);
  const [clientData, setClientData] = useState({
    vacancies: null,
    totalPositions: null,
    hiringCosts: null,
  });

  const calcAdminData = () => {
    var totalApps = 0;
    var totalAssessments = 0;
    var totalInterviews = 0;
    var totalHires = 0;

    for (var key in positions) {
      //should run async???
      var obj = positions[key];
      //adding creates 0's instead of null
      totalApps += obj.applications;
      totalAssessments += obj.assessments;
      totalInterviews += obj.interviews;
      totalHires += obj.hires;
    }

    // console.log("in calcadmindata", isAdmin);

    return {
      adminTotalClients: clients.length,
      adminTotalPositions: positions.length,
      adminFunnel: {
        applicants: totalApps,
        interviews: totalInterviews,
        assessments: totalAssessments,
        hires: totalHires,
      },
    };
  };

  const calcGroupedStats = () => {
    //admin table
    var positionsGroupedByClient = groupBy(positions, "client");
    var statsGroupedByClients = {};

    // console.log(positionsGroupedByClient);

    for (var clientId in positionsGroupedByClient) {
      var len = positionsGroupedByClient[clientId].length;

      var avgCph = positionsGroupedByClient[clientId]
        .map((a) => a.cost_per_hire)
        .filter((v) => !(v === null))
        .reduce(add, null);

      //save totHirCosts becefore division
      var totHireCost = avgCph;
      if (totHireCost) {
        totHireCost = parseFloat(totHireCost.toFixed(2));
      }

      if (avgCph) {
        avgCph = parseFloat((avgCph / len).toFixed(2));
      }

      var avgTurnRate = positionsGroupedByClient[clientId]
        .map((a) => a.turnover_rate)
        .filter((v) => !(v === null))
        .reduce(add, null);

      if (avgTurnRate) {
        avgTurnRate = parseFloat((avgTurnRate / len).toFixed(2));
      }

      var totalVacs = positionsGroupedByClient[clientId]
        .map((a) => a.vacancies)
        .filter((v) => !(v === null))
        .reduce(add, null);

      //funnel data
      var totalApps = positionsGroupedByClient[clientId]
        .map((a) => a.applications)
        .filter((v) => !(v === null))
        .reduce(add, 0);

      var totInts = positionsGroupedByClient[clientId]
        .map((a) => a.interviews)
        .filter((v) => !(v === null))
        .reduce(add, 0);

      var totAssess = positionsGroupedByClient[clientId]
        .map((a) => a.assessments)
        .filter((v) => !(v === null))
        .reduce(add, 0);

      var totHires = positionsGroupedByClient[clientId]
        .map((a) => a.hires)
        .filter((v) => !(v === null))
        .reduce(add, 0);

      //applicant sources
      var list_of_app_source = positionsGroupedByClient[clientId].map(
        (a) => a.applicant_source
      );
      var pieChartData = Object.entries(mergeSources(list_of_app_source)).map(
        (a) => getPieEntry(a)
      );

      statsGroupedByClients[clientId] = {
        client_name: positionsGroupedByClient[clientId][0].client_name,
        total_hiring_costs: totHireCost,
        avg_cost_per_hire: avgCph,
        avg_turnover_rate: avgTurnRate,
        total_vacancies: totalVacs,
        funnel_data: {
          applications: totalApps,
          interviews: totInts,
          assessments: totAssess,
          hires: totHires,
        },
        pieChartData: pieChartData,
        total_positions: positionsGroupedByClient[clientId].length,
      };
    }

    return statsGroupedByClients;
  };

  const adminData = useMemo(() => {
    return calcAdminData();
  }, [positions, clients]);

  const statsByClient = useMemo(() => {
    return calcGroupedStats();
  }, [clients, positions, isAdmin]);

  const APIData = axios.create({
    baseURL: `${host}/api`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": cookies.get("csrftoken"),
      Authorization: `Bearer ${authToken}`,
    },
    credentials: "same-origin",
  });

  APIData.interceptors.response.use(
    (response) => response,
    (error) => {
      if ("response" in error)
        if (error.response.status == 401) {
          logoutUser();
        }
      console.error(error);
      return Promise.reject(error);
    }
  );

  APIData.interceptors.request.use(
    (conf) => {
      let storageString = localStorage.getItem("authTokens");
      if (storageString) {
        let userToken = JSON.parse(storageString);
        let decodedToken = jwt_decode(userToken.access);
        let currentDate = new Date();
        if (decodedToken.exp * 1000 < currentDate.getTime()) {
          logoutUser();
          return Promise.reject(conf);
        } else {
          return conf;
        }
      } else {
        logoutUser();
        return Promise.resolve(conf);
      }
    },
    (error) => {
      console.error(error);
      debugger;
      return Promise.reject(error);
    }
  );

  const refreshPositions = () => {
    APIData.get("/position/", { params: { archived: false } })
      .then((res) => {
        //get some admin data and make float and date correction since axios can't parse floats
        let data = res.data.map((pos) => {
          return {
            ...pos,
            date_modified: new Date(pos.date_modified),
            cost_per_hire: pos.cost_per_hire
              ? parseFloat(pos.cost_per_hire)
              : null,
            turnover_rate: pos.turnover_rate
              ? parseFloat(pos.turnover_rate)
              : null,
            conversion_rate: pos.conversion_rate
              ? parseFloat(pos.conversion_rate)
              : null,
          };
        });
        setPositions(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const refreshClients = () => {
    APIData.get("/client/", { params: { archived: false } })
      .then((res) => {
        let data = res.data.map((client) => {
          return { ...client, date_modified: new Date(client.date_modified) };
        });

        setClients(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };


  const getArchivedClients = () => {
    APIData.get("/client/", { params: { archived: true } })
      .then((res) => {
        let carr = res.data.map((client) => {
          var d = client.date_modified;
          return { ...client, date_modified: new Date(d) };
        });
        setArchivedClients(carr);
      })
      .catch((error) => {
        //logout
        console.error("Error occured when getting archived clients:", error);
      });
  };
  const getArchivedPositions = () => {
    APIData.get("/position/", { params: { archived: true } })
      .then((res) => {
        let carr = res.data.map((pos) => {
          var d = pos.date_modified;
          return { ...pos, date_modified: new Date(d) };
        });
        setArchivedPositions(carr);
      })
      .catch((error) => {
        //logout
        console.error("Error occured when getting archived positions:", error);
      });
  };
  
  //The below 3 functions needs to be replaced with redux
  const del = (id, archived = false, client = false) => {
    if (client) {
      if (archived) {
        var arr = archivedClients.filter((client) => client.id !== id);
        setArchivedClients(arr);
      } else {
        const arr = clients.filter((client) => client.id !== id);
        setClients(arr);
      }
    } else {
      //position
      if (archived) {
        setArchivedPositions(archivedPositions.filter((pos) => pos.id !== id));
      } else {
        setPositions(positions.filter((pos) => pos.id !== id));
      }
    }
  };

  // update positions/clients (edits for archived doesn't work because archived clients aren't in scope for client dropdown)
  const update = (obj, client = false) => {
    //obj comes from api, so need to parse date and floats from strings
    obj.date_modified = new Date(obj.date_modified);
    console.log("hello from update");
    console.log(obj);
    if (obj.cost_per_hire != null) {
      obj.cost_per_hire = parseFloat(obj.cost_per_hire);
    }
    if (obj.turnover_rate != null) {
      obj.turnover_rate = parseFloat(obj.turnover_rate);
    }
    if (obj.conversion_rate != null) {
      obj.conversion_rate = parseFloat(obj.conversion_rate);
    }

    if (client) {
      var index = clients.findIndex((x) => x.id === obj.id);
      if (index === -1) {
        console.error("error occured when updatting client id:", obj.id);
      } else {
        setClients([
          ...clients.slice(0, index),
          Object.assign({}, clients[index], obj),
          ...clients.slice(index + 1),
        ]);
      }

      //if client name is changed, change pos.client_name
      var arr = positions.map((pos) => {
        if (pos.client === obj.id && pos.client_name != obj.name) {
          return { ...pos, client_name: obj.name };
        } else {
          return pos;
        }
      });
      setPositions(arr);
      arr = archivedPositions.map((pos) => {
        if (pos.client === obj.id && pos.client_name != obj.name) {
          return { ...pos, client_name: obj.name };
        } else {
          return pos;
        }
      });
      setArchivedPositions(arr);
    } else {
      //position
      var index = positions.findIndex((x) => x.id === obj.id);
      if (index === -1) {
        console.error("error occured when updatting position id:", obj.id);
      } else {
        setPositions([
          ...positions.slice(0, index),
          Object.assign({}, positions[index], obj),
          ...positions.slice(index + 1),
        ]);
      }
    }
  };

  //add new position/client to unarchived list
  const addObj = (obj, client = false) => {
    obj.date_modified = new Date(obj.date_modified);

    if (obj.cost_per_hire != null) {
      obj.cost_per_hire = parseFloat(obj.cost_per_hire);
    }
    if (obj.turnover_rate != null) {
      obj.turnover_rate = parseFloat(obj.turnover_rate);
    }
    if (obj.conversion_rate != null) {
      obj.conversion_rate = parseFloat(obj.conversion_rate);
    }

    if (client) {
      setClients([...clients, obj]);
    } else {
      setPositions([...positions, obj]);
    }
  };

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     refreshClients();
  //     refreshPositions();
  //   }
  // }, [isAuthenticated]);

  const contextData = {
    APIData: APIData, //axios function to call api

    del: del,
    update: update,
    addObj: addObj,

    getArchivedClients: getArchivedClients,
    getArchivedPositions: getArchivedPositions,

    archivedPositions: archivedPositions,
    setArchivedPositions: setArchivedPositions,
    archivedClients: archivedClients,
    setArchivedClients: setArchivedClients,

    positions: positions,
    setPositions: setPositions,
    clients: clients,
    setClients: setClients,

    //useMemo stuff
    adminData: adminData,
    statsByClient: statsByClient,

    //clientPosition Area stuff
    setClientFunnelData: setClientFunnelData,
    setClientData: setClientData,
    setClientPieChartData: setClientPieChartData,
    clientPositions: clientPositions,
    setClientPositions: setClientPositions,
    clientPositionId: clientPositionId,
    setClientPositionId: setClientPositionId,
    clientId: clientId,
    setClientId: setClientId,
    clientChecked: clientChecked,
    setClientChecked: setClientChecked,
    clientName: clientName,
    setClientName: setClientName,
    clientData: clientData,
    clientFunnelData: clientFunnelData,
    clientPieChartData: clientPieChartData,
  };

  return (
    <DataContext.Provider value={contextData}>{children}</DataContext.Provider>
  );
};
